import { createSelector } from 'reselect'
import { selectors as imported } from '../../imports'

export const getPinned = state => state.usersReducer.pinned

export const getActivePinned = createSelector(
    [getPinned, imported.getActiveServerId],
    (pinned, serverId) => pinned[serverId] || [],
)

export const isUserPinned = (state, serverId, userId) => {
    const pinned = getPinned(state)
    const server = pinned[serverId] || []
    return server.indexOf(userId) > -1
}

export const isActiveUserPinned = (state, userId) => {
    const server = getActivePinned(state)
    return server.indexOf(userId) > -1
}



// WEBPACK FOOTER //
// ./src/features/Users/data/pinned/selectors.js